import type { ShellControl } from '@suiteux/suiteux-shell-react';
import { getIsGulpingValue, getIsGulpOrBranchingValue } from 'owa-querystring';
import * as React from 'react';
import * as ReactDOM from 'owa-react-dom';
import headerStyles from './OwaSuiteHeader.scss';

// No need to localize this string as it is a DEV feature only
const gulpingText = 'gulping...';

// No need to localize this string as it is a DEV feature only
const branchingText = 'branching...';

// Render the gulping / branching label
function renderDevSource(container: HTMLDivElement) {
    if (getIsGulpOrBranchingValue()) {
        ReactDOM.render(
            <label className={headerStyles.devSourceLabel}>
                {getIsGulpingValue() ? gulpingText : branchingText}
            </label>,
            container
        );
    }
}

// Define the shell control that will display the dev source
export const OwaDevSourceLabel = {
    id: 'owaDevSourceLabel',
    flex: '1 1 auto',
    justifyContent: 'flex-start',
    minWidth: 'fit-content',
    render: renderDevSource,
} as ShellControl;
